import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, isRef as _isRef, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2d5be382"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-settings" }
const _hoisted_2 = { class: "subtitle" }
const _hoisted_3 = {
  key: 0,
  class: "icon-description"
}
const _hoisted_4 = { class: "subtitle" }
const _hoisted_5 = { class: "item-flex" }
const _hoisted_6 = { class: "subtitle" }
const _hoisted_7 = { class: "item-flex" }
const _hoisted_8 = { class: "subtitle" }
const _hoisted_9 = { class: "item-flex" }

import {computed, Reactive, reactive, ref} from "vue";
import {useRoute} from "vue-router";
import {useStore} from "vuex";
import config from "@/config.json";
import {Item} from "@/types/Item";
import {Guild} from "@/types/Guild";
import SelectItems from "@/utils/SelectItems";
import i18n from "@/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateItem',
  props: {
    names: {}
  },
  emits: ['create'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const route = useRoute()
const store = useStore()
let guild = computed(() => (store.getters.guilds as Array<Guild>).find(g => g.id === route.params.id));
let roles = SelectItems.roles(guild.value!.roles!)
let requiredRoles = SelectItems.roles(guild.value!.roles!, false, false)
let dialog = ref(false)
let valid = ref(true)
let loading = ref(false)
let item = {} as Item

function isUrl(str: string): boolean {
  try {
    let url = new URL(str)
    return url.protocol == 'http:' || url.protocol == 'https:'
  }
  catch (e) {
    return false
  }
}

const positiveIntegerRules = [
  (number: number) => (number >= 0 && !(number % 1)) || i18n.global.t('Items.errors.invPosNumber')
]
const nameRules = [
  (name: string) => (name.length > 0 && name.length <= 50) || i18n.global.t('Items.errors.invItemName'),
  (name: string) => (!props.names.includes(name)) || i18n.global.t('Items.errors.alreadyExists')
]
const descriptionRules = [
  (description: string) => (description.length <= 200) || i18n.global.t('Items.errors.invItemDescription')
]
const iconRules = [
  (icon: string) => ((!icon.length || isUrl(icon)) || i18n.global.t('Items.errors.invUrl'))
]

function newItem() {
  item = reactive({
    name: '',
    description: '',
    iconUrl: '',
    requiredRoles: [],
    requiredXp: 0,
    price: 0,
    xp: {min: 0, max: 0},
    addRole: null,
    removeRole: null
  })
}
newItem()

async function createItem() {
  loading.value = true;
  let response = await fetch(`${config.API}/private/guilds/${route.params.id}/items`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('token') as string
    },
    body: JSON.stringify(item)
  })
  if (response.ok) {
    dialog.value = false;
    item.newName = item.name;
    emit('create', item);
    newItem()
  }
  loading.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_toolbar_items = _resolveComponent("v-toolbar-items")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_btn, {
      color: "primary",
      variant: "outlined",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(dialog) //@ts-ignore
 ? dialog.value = true : dialog = true))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, {
          class: "btn-icon",
          size: "25"
        }, {
          default: _withCtx(() => [
            _createTextVNode("add")
          ]),
          _: 1
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('Items.subtitles.create')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: _unref(dialog),
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(dialog) ? (dialog).value = $event : dialog = $event)),
      fullscreen: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { color: "modal" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_toolbar, {
              dark: "",
              color: "primary"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  icon: "",
                  disabled: _unref(loading),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(dialog) //@ts-ignore
 ? dialog.value = false : dialog = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("close")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_toolbar_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Items.subtitles.createItem')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_toolbar_items, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      dark: "",
                      text: "",
                      disabled: _unref(valid) === false || !_unref(item).name.length,
                      loading: _unref(loading),
                      onClick: createItem
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          class: "btn-icon",
                          size: "large"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("save")
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('Items.subtitles.submit')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_v_form, {
                modelValue: _unref(valid),
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(valid) ? (valid).value = $event : valid = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('Items.subtitles.general')), 1),
                  _createVNode(_component_v_text_field, {
                    modelValue: _unref(item).name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(item).name) = $event)),
                    class: "general-item-field",
                    color: "primary",
                    counter: "50",
                    rules: nameRules,
                    label: _ctx.$t('Items.subtitles.name')
                  }, null, 8, ["modelValue", "label"]),
                  _createVNode(_component_v_textarea, {
                    modelValue: _unref(item).description,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(item).description) = $event)),
                    class: "general-item-field",
                    color: "primary",
                    counter: "200",
                    rules: descriptionRules,
                    label: _ctx.$t('Items.subtitles.description')
                  }, null, 8, ["modelValue", "label"]),
                  (!_unref(guild).settings.boost)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_router_link, {
                          class: "donate-link",
                          to: "/donate"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { size: "small" }, {
                              default: _withCtx(() => [
                                _createTextVNode("favorite")
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('Items.subtitles.donate')), 1)
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('Items.subtitles.iconDescription')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_text_field, {
                    modelValue: _unref(item).iconUrl,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(item).iconUrl) = $event)),
                    class: "general-item-field",
                    "prepend-inner-icon": "art_track",
                    disabled: !_unref(guild).settings.boost,
                    rules: iconRules,
                    color: "primary",
                    label: _ctx.$t('Items.subtitles.iconUrl')
                  }, null, 8, ["modelValue", "disabled", "label"]),
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('Items.subtitles.values')), 1),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_text_field, {
                        modelValue: _unref(item).price,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(item).price) = $event)),
                        class: "number-input",
                        color: "primary",
                        rules: positiveIntegerRules,
                        type: "number",
                        label: _ctx.$t('Items.subtitles.price')
                      }, null, 8, ["modelValue", "label"])
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_text_field, {
                        modelValue: _unref(item).requiredXp,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(item).requiredXp) = $event)),
                        class: "number-input",
                        color: "primary",
                        rules: positiveIntegerRules,
                        type: "number",
                        label: _ctx.$t('Items.subtitles.requiredXp')
                      }, null, 8, ["modelValue", "label"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('Items.subtitles.xp')), 1),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_text_field, {
                        modelValue: _unref(item).xp.min,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(item).xp.min) = $event)),
                        class: "number-input",
                        color: "primary",
                        rules: positiveIntegerRules,
                        type: "number",
                        label: _ctx.$t('Items.subtitles.minimum')
                      }, null, 8, ["modelValue", "label"])
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_text_field, {
                        modelValue: _unref(item).xp.max,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(item).xp.max) = $event)),
                        class: "number-input",
                        color: "primary",
                        rules: positiveIntegerRules,
                        type: "number",
                        label: _ctx.$t('Items.subtitles.maximum')
                      }, null, 8, ["modelValue", "label"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('Items.subtitles.roles')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_select, {
                        modelValue: _unref(item).addRole,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(item).addRole) = $event)),
                        class: "role-select",
                        color: "primary",
                        items: _unref(roles),
                        label: _ctx.$t('Items.subtitles.addRole')
                      }, null, 8, ["modelValue", "items", "label"])
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_select, {
                        modelValue: _unref(item).removeRole,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(item).removeRole) = $event)),
                        class: "role-select",
                        color: "primary",
                        items: _unref(roles),
                        label: _ctx.$t('Items.subtitles.removeRole')
                      }, null, 8, ["modelValue", "items", "label"])
                    ])
                  ]),
                  _createVNode(_component_v_select, {
                    modelValue: _unref(item).requiredRoles,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(item).requiredRoles) = $event)),
                    color: "primary",
                    items: _unref(requiredRoles),
                    multiple: "",
                    chips: "",
                    "closable-chips": "",
                    label: _ctx.$t('Items.subtitles.requiredRoles')
                  }, null, 8, ["modelValue", "items", "label"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})